/**
 * An module defining links in the footer.
 */

import { appId } from '@/config'
import AppStore from './appStore'

const appStore = new AppStore({ appId })

export default {
  columns: [
    {
      key: 'footer.endorse',
      displayName: undefined,
      links: [
        {
          text: 'Download on the App Store',
          href: appStore.link,
          title: 'What are you waiting for?',
          key: 'link.download'
        },
        {
          text: '@UltimateZmanim on Twitter',
          href: 'https://twitter.com/ultimatezmanim',
          title: 'Connect on Twitter',
          key: 'link.follow.tw'
        },
        {
          text: 'Learn About Zmanim',
          route: '/resources',
          title: 'For the curious and the bold.',
          key: 'link.info.resources'
        },
        {
          text: 'Privacy',
          route: '/privacy',
          title: 'Absolutely no compromises.',
          key: 'link.support.privacy'
        },
        {
          text: 'Legal',
          route: '/legal',
          title: 'For lawyers and folks who read Tolkien.',
          key: 'link.support.legal'
        }
        // {
        //   text: 'Take the Survey',
        //   href: undefined,
        //   title: 'Make the app even better.',
        //   key: 'link.contrib.survey',
        // },
        // {
        //   text: 'Translate Into Your Language',
        //   href: undefined,
        //   title: 'Bring Zmanim to More Jews',
        //   key: 'link.contrib.translate',
        // },
        // {
        //   text: 'FAQs',
        //   route: '/faq',
        //   title: 'Answers to Frequently Asked Questions',
        //   key: 'link.support.faq',
        // },
        // {
        //   text: 'What\'s New',
        //   route: '/changelog',
        //   title: 'Learn what\'s changed since the previous version.',
        //   key: 'link.support.changelog',
        // },
      ]
    },
    {
      key: 'footer.product',
      displayName: undefined,
      links: []
    }
  ]
}
